import { PrivateRoute } from 'components/route'
import { useHistory, useRouteMatch } from 'react-router'

import { grupoCboPlanoCuidadoObservacao } from '../acessos'
import { HistoricoPlanoCuidadoModal } from './HistoricoPlanoCuidadoModal'
import { PlanoCuidadoLotacaoModel, PlanoCuidadoModel } from './model'

interface PlanoCuidadoRootViewProps {
  planosDeCuidado: ReadonlyArray<PlanoCuidadoModel>
  atendProfIniciador: PlanoCuidadoLotacaoModel
  loading: boolean
}

export const urlPlanosDeCuidado = '/historico-de-planos-de-cuidado'

export const PlanoCuidadoRootView = (props: PlanoCuidadoRootViewProps) => {
  const { planosDeCuidado, atendProfIniciador, loading } = props
  const match = useRouteMatch()
  const history = useHistory()

  return (
    <PrivateRoute path={`${match.url}${urlPlanosDeCuidado}`} permission={grupoCboPlanoCuidadoObservacao}>
      <HistoricoPlanoCuidadoModal
        planosDeCuidado={planosDeCuidado}
        atendProfIniciador={atendProfIniciador}
        loading={loading}
        onClose={() => history.push(match.url.replace(urlPlanosDeCuidado, ''))}
      />
    </PrivateRoute>
  )
}
